

















import UserContactsForm from '@components/common/user-contacts-form.vue';
import { CONFIG } from '@constants';
import { ReservationRequestType } from '@enums';
import { Price } from '@interfaces/hybris/Price';
import navigationService from '@services/navigation-service';
import { normalizePhone } from '@services/utils';
import Vue, { PropType } from 'vue';
import { mapActions, mapState } from 'vuex';

export default Vue.extend({
	name: 'DialogReservation',
	components: { UserContactsForm },
	props: {
		fullPrice: {
			type: Object as PropType<Price>,
			required: true,
		},
	},
	computed: { ...mapState('common', ['userContacts']) },
	methods: {
		...mapActions('pdp', ['sendReservationRequest']),
		submitForm(): void {
			const data = {
				...this.userContacts,
				phone: normalizePhone(this.userContacts.phone),
				...{
					pricePlanId: this.fullPrice.code,
					type: ReservationRequestType.RESERVATION,
				},
			};

			this.sendReservationRequest({ data })
				.then(() => {
					navigationService.goTo(CONFIG.baseUrl.reservationSuccess, true);
				});
		},
	},
});
